export default "__VITE_ASSET__7ea06a9c__"